export default "__VITE_ASSET__D4iE15lm__"